var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"product-instruction pa-0 ml-0"},[_c('v-card',[_c('v-card-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.instruction)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }